export const getInstructionListNormalize = (mifareId: string, customerNumber?: number, sessionToken?: string) => {
  const formValues = {
    CustomerNumber: customerNumber,
    SessionToken: sessionToken,
    MifareId: mifareId,
    TaskOrInstruction: 0,
  };
  return formValues;
};
